<app-center-view title="Sign in" [isLoading]="isLoading" [error]="error" [success]="success">
  <app-message [class.message]="!error"></app-message>
  <form [formGroup]="signInForm">
    <app-input-form label="Email or Username" icon="person">
      <input
        type="text"
        id="username"
        formControlName="user"
        placeholder="Email or Username"
        required
        autofocus
        (keyup.enter)="doSignIn()"
      />
    </app-input-form>
    <app-input-form label="Password" icon="lock">
      <input
        type="password"
        formControlName="password"
        placeholder="Password"
        required
        (keyup.enter)="doSignIn()"
      />
    </app-input-form>
  </form>
  <button mat-raised-button appThemedButton [disabled]="!signInForm.valid" (click)="doSignIn()">
    SIGN IN
  </button>
  @if (isShowResendEmail) {
    <div>Didn't receive a verification email?</div>
    <button mat-raised-button (click)="doResendEmail()">RESEND EMAIL</button>
  }
  <div class="footer-button">
    <a class="link" routerLink="/forget-password">Forget password?</a>
    <div class="right">No account? <a routerLink="/sign-up">Sign up</a></div>
  </div>
</app-center-view>
